import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Auth uses httpOnly cookies set by the backend. We send credentials with every request.
const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export default api;

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function inr(amount) {
  return new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(amount || 0);
}

// Resolve an image path to a full URL. Relative /api/files paths are prefixed with the backend URL.
export function imgUrl(path) {
  if (!path) return "";
  if (path.startsWith("http")) return path;
  return `${BACKEND_URL}${path}`;
}

export const HOTEL_CATEGORIES = [
  { value: "hotel", label: "Hotel" },
  { value: "resort", label: "Resort" },
  { value: "villa", label: "Villa" },
  { value: "homestay", label: "Homestay" },
  { value: "apartment", label: "Apartment" },
  { value: "bnb", label: "B&B" },
  { value: "guesthouse", label: "Guesthouse" },
];

export function categoryLabel(value) {
  return (HOTEL_CATEGORIES.find((c) => c.value === value) || {}).label || "Hotel";
}

export const ROOM_TYPES = ["Single", "Double", "Triple"];
export const BED_SIZES = ["Single", "Double", "King"];
export const ROOM_COUNT_OPTIONS = Array.from({ length: 100 }, (_, i) => i + 1);

// GST slab on room tariff (per night)
export function roomGstRate(pricePerNight) {
  const p = Number(pricePerNight) || 0;
  if (p <= 1000) return 0;
  if (p <= 7500) return 0.05;
  return 0.18;
}

export const SERVICE_GST_RATES = { car: 0.05, bike: 0.05, taxi: 0.05, yacht: 0.18 };
export const CONVENIENCE_FEE = 299;
export const CONVENIENCE_FEE_GST_RATE = 0.18;
export const CONVENIENCE_FEE_GST = Math.round(CONVENIENCE_FEE * CONVENIENCE_FEE_GST_RATE * 100) / 100; // 53.82
export const OTA_SAVING_RATE = 0.30; // 30% cheaper than commission-based OTAs

// Whole-unit categories are booked as one entire place (flat price, guests up to max).
export const WHOLE_UNIT_CATEGORIES = ["villa", "apartment", "homestay"];
export function isWholeUnit(category) {
  return WHOLE_UNIT_CATEGORIES.includes((category || "").toLowerCase());
}

export function gstPct(rate) {
  return `${Math.round((rate || 0) * 100)}%`;
}
